module.exports = __webpack_public_path__ + "img/compact.701b3692.png";